import Print from '../../src/legacy/Print';
export default Print;
